<template>
    <div>
      <template v-if="registrations && registrations.length">
        <h1>Your last registrations</h1>
        <transition-group name="block-slide-in" tag="div">
          <ion-card v-for="(registration, i) in registrations" :key="i">
            <ion-card-header>
              <div class="title">
                <ion-card-title>
                  <span class="text-20">{{ getTypeLabel(registration.type) }}</span>
                </ion-card-title>
                <ion-card-title>
                  <span class="text-15">{{ formatDateTime(registration.dateAndTime) }}</span>
                </ion-card-title>
              </div>
            </ion-card-header>
          </ion-card>
        </transition-group>
      </template>
    </div>
  </template>
  
  <script>
  import { IonCard, IonCardHeader, IonCardTitle } from "@ionic/vue";
  import ApiService from "../../common/service.api";
  import { useStore } from "vuex";
  
  export default {
    name: "CheckInOutLastRegistration",
    
    data() {
      return {
        registrations: [],
        campaignData: {},
      };
    },
    components: { IonCard, IonCardHeader, IonCardTitle },
    methods: {
      formatDateTime(dateAndTime) {
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        };
        return new Intl.DateTimeFormat("es-ES", options).format(new Date(dateAndTime));
      },
      getTypeLabel(type) {
        return type === "Entrada" ? "CheckIn" : type === "Salida" ? "CheckOut" : type;
      },
    },
    mounted() {
      const store = useStore();
      const route = this.$route;
      const { id } = route.params;
      this.campaignId = id;
  const idUser = store.getters["user/getUserData"].id


      ApiService.get(`UserCheckInOut/Gets/0/${idUser}`).then((data) => {
  
        this.registrations = data.data
          .map((i) => ({
            dateAndTime: i.eventDate,
            type: i.type,
          }))
          .sort((a, b) => new Date(b.dateAndTime) - new Date(a.dateAndTime));
      });
    },
  };
  </script>
  
  <style lang="scss" scoped>
  ion-card {
    --background: var(--ion-color-primary);
    color: var(--text-color-light);
    margin-bottom: 1rem;
    width: 100%;
    ion-card-title {
      color: var(--text-color-light);
    }
  }
  
  .title {
    display: block;
    clear: both;
  }
  
  ion-card {
    margin-bottom: 1rem;
    width: 100%;
  }
  </style>
  